import { BaseTooltip, BaseTooltipContent } from 'root/src/client/v2/common/components/BaseTooltip/BaseTooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import { faLockOpen } from '@fortawesome/pro-regular-svg-icons/faLockOpen';
import { memo } from 'react';
export const DropLockStatusWidget = memo((props) => {
    const { isLocked, description } = props;
    return (<BaseTooltip tooltip={description && (<BaseTooltipContent className="flex flex-col justify-center items-center">
					{description}
				</BaseTooltipContent>)}>
			<div className="flex items-center bg-black rounded-full p-3">
				<FontAwesomeIcon size="lg" icon={(isLocked ? faLock : faLockOpen)}/>
			</div>
		</BaseTooltip>);
});
